/* Clinica Vie Et Sante - 05 Areas
   Riel expansible: avance automatico pausable, puntero y foco mandan
   sobre el autoplay, y se apaga con prefers-reduced-motion. */

class VesAreas {
  constructor(root) {
    this.root = root;
    this.panels = Array.from(root.querySelectorAll('[data-panel]'));
    if (this.panels.length === 0) return;

    this.index = 0;
    this.timer = null;
    this.paused = false;
    // M-7: pausa explicita del usuario. Distinta de this.paused, que es la
    // pausa temporal por puntero o foco: esta no se levanta sola.
    this.userPaused = false;
    this.pauseBtn = root.querySelector('[data-pause]');

    // El autoplay se apaga entero si el usuario pidió menos movimiento:
    // un carrusel que avanza solo es justamente lo que esa preferencia evita.
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.speed = parseInt(root.dataset.speed, 10) || 5000;
    this.autoplay = root.dataset.autoplay === 'true' && !this.reduced;

    this.bind();
    this.observe();
  }

  setActive(i) {
    if (i === this.index) return;
    this.index = i;
    this.panels.forEach((p, n) => p.classList.toggle('is-active', n === i));
  }

  next() {
    this.setActive((this.index + 1) % this.panels.length);
  }

  bind() {
    this.panels.forEach((panel, i) => {
      // El puntero y el teclado mandan sobre el autoplay: si el usuario
      // está mirando algo, no se lo movemos debajo.
      panel.addEventListener('pointerenter', () => {
        this.paused = true;
        this.setActive(i);
      });
      panel.addEventListener('focusin', () => {
        this.paused = true;
        this.setActive(i);
      });
    });

    this.root.addEventListener('pointerleave', () => {
      this.paused = false;
    });
    this.root.addEventListener('focusout', (e) => {
      if (!this.root.contains(e.relatedTarget)) this.paused = false;
    });

    if (this.pauseBtn) {
      this.pauseBtn.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.pauseBtn.setAttribute('aria-pressed', String(this.userPaused));
        if (this.userPaused) this.stop();
        else this.start();
      });
    }

    // Sin esto el intervalo sigue corriendo en una pestaña oculta.
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.stop();
      else if (this.visible) this.start();
    });
  }

  observe() {
    // Solo anima cuando está en pantalla.
    this.io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.visible = entry.isIntersecting;
          if (entry.isIntersecting) this.start();
          else this.stop();
        });
      },
      { threshold: 0.25 }
    );
    this.io.observe(this.root);
  }

  start() {
    if (!this.autoplay || this.timer || this.userPaused) return;
    this.timer = setInterval(() => {
      if (!this.paused) this.next();
    }, this.speed);
  }

  stop() {
    if (!this.timer) return;
    clearInterval(this.timer);
    this.timer = null;
  }
}

function initVesAreas() {
  document.querySelectorAll('[data-ves-areas]').forEach((el) => {
    if (el.dataset.vesInit === 'true') return;
    el.dataset.vesInit = 'true';
    new VesAreas(el);
  });
}

document.addEventListener('DOMContentLoaded', initVesAreas);
// El editor de temas reinyecta la sección sin recargar la página.
document.addEventListener('shopify:section:load', initVesAreas);
